export default __webpack_public_path__ + "static/media/time.52564b60.svg";